<template>
  <div class="p-dropdown-menu-animation">
    <button
      class="p-dropdown-menu-animation__trigger"
      @click="$_dropdownAnimation_toggleState"
    >
      <slot name="trigger" />
      <span class="p-dropdown-menu-animation__arrow" ref="arrowElement">
        <slot name="arrow" />
      </span>
    </button>

    <div class="p-dropdown-menu-animation__target" ref="targetElement">
      <div
        class="p-dropdown-menu-animation__target__inner"
        ref="targetContentsElement"
      >
        <slot name="target" />
      </div>
    </div>
  </div>
</template>

<script>
//import dropdownAnimation from 'assets/js/mixins/dropdownAnimation'
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import DropdownAnimation from "@/general/mixins/dropdownAnimation.ts";

@Component
export default class DropdownMenuAnimation extends mixins(DropdownAnimation) {}
</script>

<style lang="scss" scoped>
.p-dropdown-menu-animation {
  &__trigger {
    width: 100%;
    display: block;
    position: relative;
  }

  &__arrow {
    position: absolute;
    right: 0;
    top: 25%;
  }

  &__target {
    overflow: hidden;

    &__inner {
    }
  }
}
</style>
